<div class="sidebar-v2">
  <div class="sidebar-v2__container">
    <div class="sidebar-v2__section sidebar-v2__section--primary">
      <sidebar-item-v2
        [activeOptions]="{ exact: true }"
        [icon]="ProfileCircleOutline"
        [routerLink]="routes.ACCOUNT"
        label="Perfil"
        class="sidebar-v2__item" />
      <sidebar-item-v2
        [icon]="BookOutline"
        [routerLink]="routes.MY_COURSES"
        label="Mis Cursos"
        class="sidebar-v2__item" />
      <sidebar-item-v2
        [icon]="CalendarOutline"
        [routerLink]="routes.CALENDAR"
        label="Calendario"
        class="sidebar-v2__item" />
      <sidebar-item-v2
        [icon]="MedalStarOutline"
        [routerLink]="routes.MY_CERTIFICATES"
        label="Certificados"
        class="sidebar-v2__item" />
      <sidebar-item-v2
        [icon]="ShoppingBagOutline"
        [routerLink]="routes.PURCHASE_HISTORY"
        label="Compras"
        class="sidebar-v2__item" />
    </div>
    <div class="sidebar-v2__section sidebar-v2__section--secondary">
      <sidebar-item-v2
        [icon]="SettingTwoOutline"
        [routerLink]="routes.ACCOUNT_SETTINGS"
        label="Config"
        class="sidebar-v2__item" />
      <sidebar-item-v2
        (click)="logout()"
        [icon]="LogoutOutline"
        label="Salir"
        class="sidebar-v2__item" />
    </div>
  </div>
</div>
